import React from "react";
import { connect } from "react-redux";
import { ChoiceModel } from "../../models/ChoiceModel";
import { ChoiceProps, ChoiceRef } from "../../components/choices/BaseChoice";
import { StoreState } from "../../models/states/StoreState";
import { QuestionModel } from "../../models/QuestionModel";
import { VariableModel } from "../../models/VariableModel";
import { getCurrentLoop } from "../../redux/reducers/interview/navigationUtilities";

interface Props {
    choiceRef: ChoiceRef;
    choice: ChoiceModel;
    variable: VariableModel;
    isFirst?: boolean;
    isLast?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
    mobile?: boolean;
    question: QuestionModel;
    gridRendering?: boolean;
    controlType: any;
    openEnd?: string;
}

type PropsU = Props & ChoiceProps;

class ChoiceContainerImpl extends React.PureComponent<PropsU> {
    render() {
        const { controlType } = this.props;
        return React.createElement(controlType, this.props);
    }
}

const mapStateToProps = (state: StoreState, ownProps: Props): Props & ChoiceProps => ({
    ...ownProps,
    questionnaire: state.interview.questionnaire,
    language: state.interview.language,
    mentions: state.interview.variables.mentionsByVariableName[ownProps.variable.name],
    theme: state.interview.theme,
    matrix: getCurrentLoop(state.interview.navigation),
});

export const ChoiceContainer = connect(mapStateToProps)(ChoiceContainerImpl);
